export enum DtoBlocType {
  BANNER = 'banner',
  CATEGORIES_CONTAINER = 'categories',
  HOME_ADVERTORIAL = 'advertorial',
  HOME_ARTICLE_CARD = 'homeArticleCard',
  HOME_MAIN_HEADER = 'mainHeader',
  PUSH_ARTICLES = 'articleThumbnails',
  PUSH_PRODUCTS = 'articleCarouselProduct',
  INFORMATION_BLOCK = 'articleInformationBlock',
  RICH_LINK = 'richLink',
}
